/* eslint-disable camelcase */
import * as React from 'react';

import { Input } from '@lightspeed/flame/Input';

import type { Shop } from '../utils/types';

type ReorderInputProps = {
  type: 'pnt' | 'lvl';
  shop: Shop;
  readOnly: boolean;
};

export const ReorderInput: React.FC<ReorderInputProps> = ({ type, shop, readOnly }) => {
  // Mimic the behavior of the gui_defs form value setting
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    const anyElem: any = target;
    anyElem.dx = true;

    window.viewFieldChanged('view');
  };

  const handleKeyUp: React.KeyboardEventHandler<HTMLInputElement> = ({ target }) => {
    window.viewFieldChanged('view', target as HTMLInputElement);
  };

  return (
    <Input
      id={`view_reorder_${type}_shop${shop.shop_id}`}
      readOnly={readOnly}
      name={`reorder_${type}_shop${shop.shop_id}`}
      className="view_view number data_control"
      data-test={`item-reorder-${type === 'pnt' ? 'point' : 'level'}-input`}
      title={`${shop.name} reorder ${type === 'pnt' ? 'point' : 'level'}`}
      type="number"
      maxLength={15}
      style={{ textAlign: 'right' }}
      defaultValue={type === 'pnt' ? shop.reorder_point : shop.reorder_level}
      onChange={handleChange}
      onKeyUp={handleKeyUp}
    />
  );
};
